<template>
  <div class="airlineChannel">
    <div class="airlineChannel__header">
      <div class="airlineChannel__header__left">
        <h1 class="medium-title">Airlines</h1>
        <div class="airlineChannel__header__left__menubar">
          <router-link class="regular-font" tag="li" :to="{name: 'airlinemedia'}">Media</router-link>
          <router-link class="regular-font" tag="li" :to="{name: 'airlineplacement'}">Placement</router-link>
        </div>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'adx-airline-channel',
  components: {

  },
  props: {

  },
  data() {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    addNew() {
        this.$router.push({name: 'addmediaairline'})
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>